module.exports = __webpack_public_path__ + "static/media/553SunsetAveNW_2018-06-06_54.8cc57fe2.jpg";